﻿const MAX_CREATURES = 16;

import {Core} from "../Base/Core";
import {GameManager} from "./GameManager";
import {CreatureController} from "./CreatureController";

export class EpochController {

    gameController; // EpochsController
    epochId = 0;
    epochData; // EpochData
    bubblesNumber = 0;
    creatures = []; // List<CreatureController>

    get EnoughSpaceForSpawn() {
        return this.creatures.length + this.bubblesNumber < MAX_CREATURES;
    }

    IsEnoughSpaceForMerge() {
        return this.creatures.length + this.bubblesNumber - 2 < MAX_CREATURES;
    }

    Init(epochId, gameController) {
        this.gameController = gameController;
        this.creatures = []; // List<CreatureController>();
        this.epochId = epochId;
        this.epochData = Core.GameData.Epochs.GetById(epochId);
    }

    ClearAll() {
        while (this.bubblesNumber > 0) {
            this.DespawnBubble();
        }

        for (let i = this.creatures.length - 1; i >= 0; i--) {
            this.creatures[i].RemoveCreature();
        }
    }

    SpawnBubble() {
        if (this.EnoughSpaceForSpawn) {
            this.bubblesNumber++;
            if (!GameManager.Prespawn) {
                Core.Player.PlanetsSave.AddBubble();
            }
            return true;
        }
        return false;
    }

    DespawnBubble() {
        if (this.bubblesNumber > 0) {
            this.bubblesNumber--;
            if (!GameManager.Prespawn) {
                Core.Player.PlanetsSave.RemoveBubble();
            }
        }
    }

    GetMoneySoftSpeed() {
        let sum = 0n;
        for (let c of this.creatures) {
            sum += BigInt(~~c.creatureData.GetSoftPerSecond());
        }
        return sum;
    }

    AddCreature(creatureId, checkForEnoughSpace) {
        if (this.EnoughSpaceForSpawn || !checkForEnoughSpace) {
            let newCreature = new CreatureController();
            newCreature.Init(creatureId, this);
            this.creatures.push(newCreature);
            if (!GameManager.Prespawn) {
                Core.Player.PlanetsSave.CurrentPlanet.AddCreature(creatureId);
            }
            return newCreature;
        }
        return null;
    }

    RemoveCreature(creature) {
        let idx = this.creatures.indexOf(creature);
        if (idx >= 0) this.creatures.splice(idx, 1);
        this.gameController.OnCreatureRemoved();
        if (!GameManager.Prespawn) {
            Core.Player.PlanetsSave.RemoveCreature(creature.creatureId);
        }
    }
}
